import slick from 'slick-carousel';
import lity from 'lity';

import 'greensock';

import "./components/popup/popup";
import "./components/popup/demo";
import "./modules/barba";

import "./animations/pageTransitions/OpenHeader";
import "./animations/pageTransitions/HomeHeader";
